import Vue from 'vue';
import 'babel-polyfill';

import '@assets/styles/default.css';
import 'element-ui/lib/theme-chalk/index.css';
import '@assets/styles/theme.less';
import '@assets/styles/iconfont.css';

import '@components/core/registerAjax';
import '@components/core/registerComponent';
import '@components/core/registerFilter';
import '@components/core/registerDirective';

import Account from '../routers/Account/Account.vue';
import router from '../routers/Account/router';
import { vueErrorHandel } from '@components/util/vueErrorHandel';

import { lxCidTracker } from '@util/lxTracker';

Vue.config.productionTip = false;

global.vm = new Vue({
  el: '#app',
  router,
  template: '<Account />',
  components: {Account}
});

if (global.vm.$route.path !== '/') {
  global.vm.$router.replace('/');
}

if (self !== top) {
  window.top.location.href="/";
}

router.afterEach((to, from) => {
  // 统计代码
  if (from.name) {
    _hmt.push(['_trackPageview'
      , '/#' + to.fullPath
      , window.location.origin]);
  } else {
    _hmt.push(['_trackPageview'
      , '/#' + to.fullPath]);
  }
  let meta = to.meta;
  // owl 统计代码
  window.Owl && window.Owl.config({
    pageUrl: `${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${to.path}`
  });
  // 灵犀埋点
  meta.cid && lxCidTracker(meta.cid);
});

// vue捕获报错信息 && cat 错误日志上报
Vue.config.errorHandler = vueErrorHandel;



// WEBPACK FOOTER //
// ./src/views/account.js